module.exports = __webpack_public_path__ + "LatoLatin-LightItalic.74baf0056f7fa382e6c7.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-LightItalic.ttf
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-LightItalic.ttf
// module chunks = styles